import {
  Box,
  Grid,
  FormLabel,
  Button,
  Card,
  Typography,
  FormHelperText,
  IconButton,
} from "@mui/material";

import { useState, useEffect, useCallback } from "react";
import { useTheme } from "@mui/material/styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link } from "react-router-dom";
import { AddMerchantData } from "../../static-models/merchantFormData";
import { constant } from "../../constants";
import { APIConstants } from "../../constants/ApiConstants";
import axios from "axios";
import BasicModal from "../ui/BasicModal";
import Loader from "../ui/Loader";
import UploadImage from "../ui/UploadImage";
import { findChangedValues } from "../../components/forms/utility";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../redux/hooks";
import useButtonStyles from "../../styles/useButtonStyles";
import BasicTextField from "../forms/formElements/BasicTextField";
import SelectInputField from "../forms/formElements/SelectInputField";
import CheckBoxSection from "../forms/formElements/CheckBoxSection";
import CloseIcon from "@mui/icons-material/Close";
import { filterConstants } from "../../constants/AppConstants";

export interface AddMerchantFormProps {
  initialFormData: AddMerchantFormType;
  type: "Add" | "Update";
  merchantId?: string;
  closeUpdate: Function;
}

export interface AddMerchantFormType {
  merchant_name: string;
  unit_number: string;
  towerNumber: string;
  leaseID: string;
  zone: string;
  merchant_logo: string;
  merchant_web_logo: string;
  isSponsored: boolean;
  promo_image: string;
  detail_image: string;
  directory_category: string;
  directory_subcategory: string;
  username: string;
  company_name: string;
  email: string;
  website: string;
  mobile_no: string;
  about_merchant: string;
  password: string;
  confirm_password: string;
  pin: string;
  confirmPin: string;
  opening_hours: string;
  isFeatured: boolean;
  isParticipating: boolean;
  hideFromDirectory: boolean | string;
  HalalCertified: boolean | string;
  payWithPoints: boolean | string;
  acceptsVoucher: boolean | string;
  earnPoints: boolean | string;
  partner: boolean | string;
  status: string;
}

const UpdateMerchantDetailsNewUI = (props: AddMerchantFormProps) => {
  const convertToBoolean = (value: string | boolean): boolean => {
    if (typeof value === "boolean") {
      return value;
    }
    return value.toLowerCase() === "yes";
  };

  const { initialFormData, type, merchantId, closeUpdate } = props;
  const [clearForm, setClearForm] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [disableSubmitMerchant, setDisableSubmitMerchant] = useState(false);
  const [disableSubmitPromo, setDisableSubmitPromo] = useState(false);
  const [disableSubmitDetails, setDisableSubmitDetails] = useState(false);
  const theme = useTheme();
  const [merchantFormState, setMerchantFormState] =
    useState<AddMerchantFormType>(initialFormData);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [uploadError, setUploadError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [disableButton, setDisableButton] = useState<boolean>(false);
  const [merchants, setMerchants] = useState<string[]>([]);
  const navigate = useNavigate();
  const buttonStyles = useButtonStyles();
  const addMerchant = async () => {
    setLoading(true);
    try {
      let addMerchantData = {
        merchant_name: merchantFormState.merchant_name,
        unit_number: merchantFormState.unit_number,
        towerNumber: merchantFormState.towerNumber,
        leaseID: merchantFormState.leaseID,
        zone: merchantFormState.zone,
        isSponsored: merchantFormState.isSponsored,
        merchant_logo: merchantFormState.merchant_logo,
        merchant_web_logo: merchantFormState.merchant_web_logo,
        promo_image: merchantFormState.promo_image,
        detail_image: merchantFormState.detail_image,
        directory_category: merchantFormState.directory_category,
        directory_subcategory: merchantFormState.directory_subcategory,
        username: merchantFormState.username,
        email: merchantFormState.email,
        company_name: merchantFormState.company_name,
        website: merchantFormState.website,
        mobile_no: merchantFormState.mobile_no,
        about_merchant: merchantFormState.about_merchant,
        pin: merchantFormState.pin,
        confirmPin: merchantFormState.confirmPin,
        opening_hours: merchantFormState.opening_hours,
        isFeatured: merchantFormState.isFeatured,
        isParticipating: merchantFormState.isParticipating,
        hideFromDirectory: merchantFormState.hideFromDirectory,
        HalalCertified: merchantFormState.HalalCertified,
        payWithPoints: merchantFormState.payWithPoints,
        acceptsVoucher: merchantFormState.acceptsVoucher,
      };
      if (type === "Add") {
        await axios.post(
          process.env.REACT_APP_API_URL + APIConstants.merchant,
          addMerchantData
        );
        setTimeout(() => {
          navigate("/viewMerchant");
        }, 3000);
      }
      if (type === "Update") {
        let changedValues: any = await findChangedValues(
          initialFormData,
          addMerchantData
        );
        if (Object.keys(changedValues).length === 0) {
          return;
        }
        changedValues = {
          ...changedValues,
          ...{
            merchant_id: merchantId,
            oldmerchant_name: initialFormData.merchant_name,
          },
        };

        await axios.patch(
          process.env.REACT_APP_API_URL + APIConstants.merchant,
          changedValues
        );
        setTimeout(() => {
          navigateToMerchant();
        }, 3000);
      }
      setUploadError(false);
    } catch (error) {
      setUploadError(true);
    } finally {
      setLoading(false);
      setShowModal(true);
      setClearForm(true);
      setTimeout(() => {
        setClearForm(false);
      }, 2000);
    }
  };
  const submitHandler = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    if (
      !merchantFormState.merchant_logo ||
      !merchantFormState.merchant_web_logo
    ) {
      setDisableSubmitMerchant(true);
      setDisableButton(true);
    } else {
      setDisableSubmitMerchant(false);
      setDisableButton(false);
    }
    if (merchantFormState.isSponsored && merchantFormState.promo_image === "") {
      setDisableSubmitPromo(true);
      setDisableButton(true);
    } else {
      setDisableSubmitPromo(false);
      setDisableButton(false);
    }
    if (
      merchantFormState.isSponsored &&
      merchantFormState.detail_image === ""
    ) {
      setDisableSubmitDetails(true);
      setDisableButton(true);
    } else {
      setDisableSubmitDetails(false);
      setDisableButton(false);
    }
    await addMerchant();
    setMerchantFormState(AddMerchantData);
    setTimeout(() => {
      setClearForm(false);
    }, 1000);
    setClearForm(true);
  };
  const merchantList = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList.merchantList
  );
  const subCategory = merchantList.reduce((sub: any, item: any) => {
    if (
      item.directorySubCategory !== "-" &&
      item.directorySubCategory.trim() !== "" &&
      !sub.includes(item.directorySubCategory)
    ) {
      sub.push(item.directorySubCategory);
    }
    return sub;
  }, []);
  const zone = [
    "Tower 1",
    "Tower 2",
    "Tower 3",
    "Tower 4",
    "Tower 5",
    "Sky Garden",
    "Atrium (Convention Centre)",
    "Fountain Court",
    "Suntec City",
    "Suntec+",
  ];

  const directoryCategory = merchantList.reduce((dir: any, item: any) => {
    if (
      item.directoryCategory !== "-" &&
      item.directoryCategory !== " " &&
      !dir.includes(item.directoryCategory)
    ) {
      dir.push(item.directoryCategory);
    }
    return dir;
  }, []);

  const navigateToMerchant = () => {
    // navigate("/viewMerchant");
    if (closeUpdate) closeUpdate(false);
  };
  return (
    <Grid px={2}>
      <Grid
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        px={3}
        pt={2}
      >
        <Typography
          sx={{
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.large,
            fontWeight: theme.font?.fontWeight.thick,
          }}
        >
          Update Profile
        </Typography>
        <IconButton
          aria-label="delete"
          onClick={closeUpdate ? () => closeUpdate(false) : () => {}}
        >
          <CloseIcon />
        </IconButton>
      </Grid>
      <Grid
        p={3}
        component={"form"}
        onSubmit={submitHandler}
        container
        marginTop={1}
      >
        <Grid
          container
          display={"flex"}
          mb={2}
          spacing={2}
          rowSpacing={3}
          paddingBottom={4}
        >
          <Grid item display={"flex"} flexDirection={"column"} width={"33.33%"}>
            <BasicTextField
              type={"text"}
              id={"merchant_name"}
              required={true}
              defaultValue={initialFormData.merchant_name || ""}
              setState={setMerchantFormState}
              placeholder=""
              stateKey="merchant_name"
              label="Merchant Name *"
              align="left"
              disableSubmit={setDisableSubmit}
              clear={clearForm}
              existingValues={merchants}
            />
          </Grid>
          <Grid item display={"flex"} flexDirection={"column"} width={"33.33%"}>
            <BasicTextField
              id={"unit_number"}
              required={true}
              defaultValue={initialFormData.unit_number}
              setState={setMerchantFormState}
              placeholder=""
              stateKey="unit_number"
              label="Unit Number *"
              align="left"
              disableSubmit={setDisableSubmit}
              clear={clearForm}
            />
          </Grid>
          <Grid item display={"flex"} flexDirection={"column"} width={"33.33%"}>
            {" "}
            <FormLabel sx={{ textAlign: "left", fontWeight: "600" }}>
              Zone *:
            </FormLabel>
            <SelectInputField
              setState={setMerchantFormState}
              stateKey="zone"
              defaultValue={initialFormData.zone}
              align="left"
              required
              options={zone}
              error={merchantFormState.zone === ""}
            />
          </Grid>
        </Grid>
        <Grid
          container
          display={"flex"}
          mb={2}
          spacing={2}
          rowSpacing={3}
          paddingBottom={4}
        >
          <Grid item display={"flex"} flexDirection={"column"} width={"33.33%"}>
            <BasicTextField
              id={"about_merchant"}
              multiline
              rows={1}
              setState={setMerchantFormState}
              placeholder=""
              stateKey="about_merchant"
              label="About Merchant"
              align="left"
              clear={clearForm}
              defaultValue={initialFormData.about_merchant}
            />
          </Grid>
          <Grid
            item
            display={"flex"}
            flexDirection={"column"}
            width={"33.33%"}
            mt={3}
          >
            <UploadImage
              setState={setMerchantFormState}
              stateKey="merchant_logo"
              // error={disableSubmitMerchant}
              disableSubmit={setDisableSubmitMerchant}
              label="Merchant Logo"
              clear={clearForm}
              value={
                merchantFormState.merchant_logo || initialFormData.merchant_logo
              }
            />
          </Grid>
        </Grid>

        <Grid container display={"flex"} mb={2} spacing={2} paddingBottom={4}>
          <Grid item display={"flex"} flexDirection={"column"} width={"33.33%"}>
            <FormLabel sx={{ textAlign: "left", fontWeight: "600" }}>
              Directory Category *:
            </FormLabel>
            <SelectInputField
              setState={setMerchantFormState}
              stateKey="directory_category"
              defaultValue={initialFormData.directory_category}
              align="left"
              options={directoryCategory}
              required
              error={merchantFormState.directory_category === ""}
            />
          </Grid>
          <Grid item display={"flex"} flexDirection={"column"} width={"33.33%"}>
            <FormLabel sx={{ textAlign: "left", fontWeight: "600" }}>
              Directory Sub Category *:
            </FormLabel>
            <SelectInputField
              setState={setMerchantFormState}
              stateKey="directory_subcategory"
              defaultValue={initialFormData.directory_subcategory}
              align="left"
              required
              options={subCategory}
              error={merchantFormState.directory_subcategory === ""}
            />
          </Grid>
          <Grid item display={"flex"} alignItems={"end"} width={"33.33%"}>
            <CheckBoxSection
              setState={setMerchantFormState}
              items={[
                {
                  stateKey: "HalalCertified",
                  value: "Halal Certified",
                  checked: convertToBoolean(merchantFormState.HalalCertified),
                },
              ]}
            />
          </Grid>
        </Grid>

        <Grid container display={"flex"} mb={2} spacing={2} paddingBottom={4}>
          <Grid item display={"flex"} flexDirection={"column"} width={"33.33%"}>
            <BasicTextField
              id={"company_name"}
              required={true}
              setState={setMerchantFormState}
              placeholder=""
              stateKey="company_name"
              label="Company Name *"
              align="left"
              disableSubmit={setDisableSubmit}
              clear={clearForm}
              defaultValue={initialFormData.company_name}
            />
          </Grid>
          <Grid item display={"flex"} flexDirection={"column"} width={"33.33%"}>
            <BasicTextField
              id={"email"}
              setState={setMerchantFormState}
              placeholder=""
              stateKey="email"
              label="Email *"
              align="left"
              required={true}
              disableSubmit={setDisableSubmit}
              clear={clearForm}
              defaultValue={initialFormData.email}
            />
          </Grid>
          <Grid item display={"flex"} flexDirection={"column"} width={"33.33%"}>
            {/* change to phone number */}
            <BasicTextField
              id={"mobile_no"}
              setState={setMerchantFormState}
              placeholder=""
              stateKey="mobile_no"
              label="Phone"
              align="left"
              clear={clearForm}
              defaultValue={initialFormData.mobile_no}
            />
          </Grid>
        </Grid>

        <Grid
          container
          display={"flex"}
          mb={2}
          py={3}
          justifyContent={"left"}
          alignItems={"left"}
          borderBottom={theme.border?.smallGrey}
          borderTop={theme.border?.smallGrey}
        >
          <Grid item display={"flex"} alignItems={"left"} width={"25%"}>
            <CheckBoxSection
              setState={setMerchantFormState}
              items={[
                {
                  stateKey: "acceptsVoucher",
                  value: "Voucher Accepted",
                  checked: convertToBoolean(merchantFormState.acceptsVoucher),
                },
              ]}
            />
          </Grid>
          <Grid item display={"flex"} alignItems={"left"} width={"25%"}>
            <CheckBoxSection
              setState={setMerchantFormState}
              items={[
                {
                  stateKey: "payWithPoints",
                  value: "Earn Points",
                  checked: convertToBoolean(merchantFormState.payWithPoints),
                },
              ]}
            />
          </Grid>
          <Grid item display={"flex"} alignItems={"left"} width={"25%"}>
            <CheckBoxSection
              setState={setMerchantFormState}
              items={[
                {
                  stateKey: "hideFromDirectory",
                  value: "Hide From Directory",
                  checked: convertToBoolean(
                    merchantFormState.hideFromDirectory
                  ),
                },
              ]}
            />
          </Grid>
          <Grid item display={"flex"} alignItems={"left"} width={"25%"}>
            <CheckBoxSection
              setState={setMerchantFormState}
              items={[
                {
                  stateKey: "partner",
                  value: "Partner",
                  checked: convertToBoolean(merchantFormState.partner),
                },
              ]}
            />
          </Grid>
        </Grid>
        <Grid container display={"flex"} mb={2} spacing={2}>
          <Grid item display={"flex"} flexDirection={"column"} width={"25%"}>
            <FormLabel sx={{ textAlign: "left", fontWeight: "600" }}>
              Status
            </FormLabel>
            <SelectInputField
              setState={setMerchantFormState}
              stateKey="status"
              defaultValue={initialFormData.status}
              align="left"
              options={[filterConstants.Active, filterConstants.Inactive]}
            />
          </Grid>
        </Grid>

        <Grid
          container
          marginTop={4}
          item
          justifyContent={"right"}
          padding={2}
          pt={3}
          pb={4}
          borderTop={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
          display={"flex"}
          gap={2}
        >
          <Button
            sx={{ ...buttonStyles.outlinedSecondary, width: "25%" }}
            variant="outlined"
            onClick={navigateToMerchant}
          >
            Cancel
          </Button>

          <Button
            disabled={disableSubmit}
            type="submit"
            sx={{ ...buttonStyles.containedSecondary, width: "25%" }}
            variant="contained"
          >
            Save
          </Button>
        </Grid>
        {showModal &&
          (uploadError ? (
            <BasicModal
              title={"Something went wrong"}
              success={false}
              setState={setShowModal}
            />
          ) : (
            <BasicModal
              title={
                type === "Add"
                  ? "Add Merchant Request is Raised Successfully!"
                  : "Update Merchant Request is Raised Successfully!"
              }
              success={true}
              setState={setShowModal}
            />
          ))}
        {loading && <BasicModal content={<Loader />} />}
      </Grid>
    </Grid>
  );
};
export default UpdateMerchantDetailsNewUI;
